<template>
  <FormElement type="input" free-height :styles="styles">
    <template slot="label">
      <span>{{ label }}</span>
    </template>

    <template slot="warning">
      <span class="-require" v-if="required">*ต้องกรอกข้อมูล</span>
    </template>

    <template slot="controller">
      <slot name="controller" />
      <button class="--input-clear" @click="input = prev">
        <vs-icon icon="restore" size="small"></vs-icon>
      </button>
      <button class="--input-clear" @click="input = ''">
        <vs-icon icon="delete_forever" size="small"></vs-icon>
      </button>
    </template>

    <div class="input-box">
      <textarea
        v-model="input"
      />
    </div>
  </FormElement>
</template>

<script>
import FormElement from '../form-element';

export default {
  components: {
    FormElement
  },
  props: {
    label: String,
    prop: String,
    required: {
      type: Boolean,
      default: false,
    },
    edata: {
      type: [String, Number],
      default: null
    },
    dataType: String,
    styles: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    input: "",
    prev: "",
  }),
  watch: {
    input: function (val) {
      if (this.prop) {
        this.$emit("input", { prop: this.prop, data: val });
      }
    },
    edata: function (val) {
      if (val) {
        if (this.dataType === "string") {
          this.input = this.edata.toString();
        } else if (this.dataType === "number") {
          this.input = parseInt(this.edata);
        } else {
          this.input = this.edata;
        }
      }
      if (this.prev === "") {
        this.prev = this.edata;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-box {
  height: 100%;

  & textarea {
    border-color: transparent;
    height: 100%;
    width: 100%;
    resize: none;
    border-radius: 8px;
    margin-left: 10px;
    font-size: 1.2rem;
    letter-spacing: 0.75px;
  }
}

.--input-clear {
  &:hover {
    color: red !important;
  }
}
</style>
